import Close from './Close';
import Download from './Download';
import Draw from './Draw';
import EraseNotes from './EraseNotes';
import Highlight from './Highlight';
import Notes from './Notes';
import NoteYellow from './NoteYellow';
import PagePrev from './PagePrev';
import PageNext from './PageNext';
import Print from './Print';
import Rotate from './Rotate';
import ToggleComments from './ToggleComments';
import TogglerThumbs from './TogglerThumbs';
import ZoomIn from './ZoomIn';
import ZoomOut from './ZoomOut';
import Undo from './Undo';
import Redo from './Redo';
import ColorSelectionDropdown from './ColorSelectionDropdown';

export {
    Close,
    Download,
    Draw,
    EraseNotes,
    Highlight,
    Notes,
    NoteYellow,
    PageNext,
    PagePrev,
    Print,
    Rotate,
    ToggleComments,
    TogglerThumbs,
    ZoomIn,
    ZoomOut,
    Undo,
    Redo,
    ColorSelectionDropdown,
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/index.js